import { z } from 'zod'

export const PiloteBaseRecordZod = z.object({
  id: z.number(),
  central_id: z.number(),
  number: z.number(),
  phone_number: z.string(),
  version: z.number(),
})
